module.exports = __webpack_public_path__ + "img/subway_harkov.cfef251.png";